import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { fetchHomeContent } from '../api/home';

const HomeContentContext = createContext({
  homeContent: null,
  loading: true,
  setHomeContent: () => {},
  updateFeaturedFromAssistant: () => {},
});

export const HomeContentProvider = ({ children }) => {
  const [homeContent, setHomeContent] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;
    const load = async () => {
      try {
        setLoading(true);
        const data = await fetchHomeContent();
        if (!isMounted) return;
        setHomeContent(data);
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error('Failed to load home content:', err);
      } finally {
        if (isMounted) setLoading(false);
      }
    };
    load();
    return () => { isMounted = false; };
  }, []);

  const updateFeaturedFromAssistant = ({ affirmation, video, audio }) => {
    setHomeContent((prev) => {
      const current = prev || {};
      const next = { ...current };
      if (affirmation) {
        // Expecting { text, imageUrl, chakra?, textColor?, fontFamily? }
        next.featuredAffirmation = {
          ...(current.featuredAffirmation || {}),
          ...affirmation,
        };
      }
      if (video) {
        // Expecting luna-api video object shape
        next.featuredVideo = { ...(current.featuredVideo || {}), ...video };
      }
      if (audio) {
        // Expecting luna-api audio object shape
        next.featuredAudio = { ...(current.featuredAudio || {}), ...audio };
      }
      return next;
    });
  };

  const value = useMemo(() => ({
    homeContent,
    loading,
    setHomeContent,
    updateFeaturedFromAssistant,
  }), [homeContent, loading]);

  return (
    <HomeContentContext.Provider value={value}>
      {children}
    </HomeContentContext.Provider>
  );
};

export const useHomeContent = () => useContext(HomeContentContext); 